import React from 'react';
import { Document, Page, Text, View, Image } from '@react-pdf/renderer';
import { sharedStyles } from './SharedPDFStyles';

const InsaatReportPDF = ({ data, logos }) => {
  return (
    <Document>
      <Page size="A4" style={sharedStyles.page}>
        <View style={sharedStyles.header}>
          <View style={sharedStyles.businessInfo}>
            {logos.length > 0 && (
              <View style={sharedStyles.logoContainer}>
                {logos.slice(0, 3).map((logo, index) => (
                  <Image key={index} src={logo.data} style={sharedStyles.logo} />
                ))}
              </View>
            )}
            <Text style={sharedStyles.businessName}>{data.projectName || 'Project Name'}</Text>
            <Text style={sharedStyles.businessDetails}>Client: {data.clientName}</Text>
            <Text style={sharedStyles.businessDetails}>Location: {data.location}</Text>
          </View>
          <View style={sharedStyles.documentTitle}>
            <Text style={sharedStyles.title}>Construction Expense Report</Text>
            <Text style={sharedStyles.documentInfo}>Date: {data.date}</Text>
            <Text style={sharedStyles.documentInfo}>Report Date: {data.reportDate}</Text>
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Construction Materials</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>Material Name</Text>
              <Text style={sharedStyles.tableCellCenter}>Unit</Text>
              <Text style={sharedStyles.tableCellCenter}>Quantity</Text>
              <Text style={sharedStyles.tableCellRight}>Unit Price</Text>
              <Text style={sharedStyles.tableCellRight}>Total</Text>
            </View>
            {data.materials && data.materials.map((material, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 2 }}>{material.materialName}</Text>
                <Text style={sharedStyles.tableCellCenter}>{material.unit}</Text>
                <Text style={sharedStyles.tableCellCenter}>{material.quantity}</Text>
                <Text style={sharedStyles.tableCellRight}>${material.unitPrice.toFixed(2)}</Text>
                <Text style={sharedStyles.tableCellRight}>${material.total.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.section}>
          <Text style={sharedStyles.sectionTitle}>Additional Expenses</Text>
          <View style={sharedStyles.table}>
            <View style={sharedStyles.tableHeader}>
              <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>Expense Item</Text>
              <Text style={sharedStyles.tableCellRight}>Amount</Text>
            </View>
            {data.additionalExpenses && data.additionalExpenses.map((expense, index) => (
              <View key={index} style={sharedStyles.tableRow}>
                <Text style={{ ...sharedStyles.tableCell, flex: 3 }}>{expense.expenseItem}</Text>
                <Text style={sharedStyles.tableCellRight}>${expense.amount.toFixed(2)}</Text>
              </View>
            ))}
          </View>
        </View>

        <View style={sharedStyles.summary}>
          <View style={sharedStyles.summaryBox}>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Material Cost:</Text>
              <Text style={sharedStyles.summaryValue}>${data.materialCost?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryRow}>
              <Text style={sharedStyles.summaryLabel}>Additional Cost:</Text>
              <Text style={sharedStyles.summaryValue}>${data.additionalCost?.toFixed(2) || '0.00'}</Text>
            </View>
            <View style={sharedStyles.summaryTotal}>
              <Text style={sharedStyles.summaryTotalLabel}>Total Cost:</Text>
              <Text style={sharedStyles.summaryTotalValue}>${data.totalCost?.toFixed(2) || '0.00'}</Text>
            </View>
          </View>
        </View>

        {data.notes && (
          <View style={sharedStyles.notes}>
            <Text style={sharedStyles.notesTitle}>Notes:</Text>
            <Text style={sharedStyles.notesText}>{data.notes}</Text>
          </View>
        )}

        <View style={sharedStyles.footer}>
          <Text>© 2025 Software Development East Africa (SODEAF) — Innovating for a smarter Africa.</Text>
          <Text>Crafted by Eng. Mohamed Ibrahim Abdi (Moha-Qadar) | mohamedqadar280@gmail.com</Text>
        </View>
      </Page>
    </Document>
  );
};

export default InsaatReportPDF;
